<template>
  <section>
    <!--工具条-->
    <el-col :span="4" class="toolbar">
      <el-button type="primary" size="small" @click="addFormVisible = true">新增</el-button>
    </el-col>

    <el-table :data="tableData"
              v-loading="listLoading">
              <el-table-column
        label="活动编号"
        prop="activity_id"
        align="center">
      </el-table-column>
      <el-table-column
        label="活动名称"
        prop="activity_name"
        align="center">
      </el-table-column>
      <el-table-column
        label="商品活动价"
        prop="discount_price"
        align="center">
      </el-table-column>
      <el-table-column
        label="是否单品"
        prop="is_single"
        align="center">
        <template scope="scope">
          <div v-if="scope.row.is_single == 0">否</div>
          <div v-else>是</div>
        </template>
      </el-table-column>
      <el-table-column
        label="开始时间"
        prop="start_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="结束时间"
        prop="end_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="更新时间"
        prop="update_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        prop="event_unique_key"
        align="center">
        <template scope="scope">
          <el-button :plain="true" type="info" size="small" @click="showGoodsForm(scope.row)">选择商品</el-button>
          <el-button :plain="true" type="info" size="small" @click="showEditForm(scope.row)">修改</el-button>
          <el-button :plain="true" type="danger" size="small" @click="deleteDate(scope.row.activity_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible">
      <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
        <el-form-item label="活动名称" prop="activity_name">
          <el-input v-model="addForm.activity_name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="商品活动价" prop="discount_price">
          <el-input v-model="addForm.discount_price" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="是否单品" prop="is_single">
          <el-switch
            v-model="addForm.is_single"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker
            v-model="addForm.start_time"
            type="datetime"
            placeholder="选择开始时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker
            v-model="addForm.end_time"
            type="datetime"
            placeholder="选择结束时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
      <el-form :model="editForm" label-width="150px" :rules="formRules" ref="editForm">
        <el-form-item label="活动名称" prop="activity_name">
          <el-input v-model="editForm.activity_name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="商品活动价" prop="discount_price">
          <el-input v-model="editForm.discount_price" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="是否单品" prop="is_single">
          <el-switch
            v-model="editForm.is_single"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker
            v-model="editForm.start_time"
            type="datetime"
            placeholder="选择开始时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker
            v-model="editForm.end_time"
            type="datetime"
            placeholder="选择结束时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--选择商品页面-->
    <el-dialog title="选择商品" v-model="selectGoodsVisible">
      <div class="select-goods">
        <el-tree class="goods-tree" highlight-current :data="goodsTypeData" @node-click="handleNodeClick"></el-tree>
        <div class="goods-data">
          <el-checkbox-group v-model="selectGoodsData" v-if="goodsData && goodsData.length > 0">
            <el-checkbox v-for="item of goodsData" :label="item.name+'-'+item.value" :key="item.value" ></el-checkbox>
          </el-checkbox-group>
          <div v-else class="no-goods">暂无数据</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="selectGoodsSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import {formatPara} from '../../static/js/util.js';

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:15,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        addForm: {
          activity_name: '',
          start_time: '',
          end_time: '',
          discount_price: '',
          is_single: '0',
          pro_ids: '',
          create_time: '',
          update_time: '',
          status: 0
        },
        editFormVisible: false,
        editForm: {},
        formRules: {},
        selectGoodsVisible: false,
        goodsTypeData: [],
        goodsData: [],
        selectGoodsData: [],
        activityId: 0,
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getList(this.query);
      },
      getList(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/activity/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
          } else {
            this.$message({
              message: data.msg,
              type: 'warning'
            });
          }
          this.listLoading = false;
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'warning'
          });
        })
      },
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.addForm));
              para.sort = parseInt(para.sort);
              para.discount_price = parseInt(para.discount_price);
              para.is_single = parseInt(para.is_single);
              //异步请求
              this.$axios.post(config.api_url + '/activity',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.editForm));
              para.sort = parseInt(para.sort);
              para.discount_price = parseInt(para.discount_price);
              para.is_single = parseInt(para.is_single);
              //异步请求
              this.$axios.put(config.api_url + '/activity',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      deleteDate(id) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.delete(config.api_url + '/activity/' + id
          ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.search();
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              });
            }
          }).catch(error => {
            this.$message({
              message: '删除异常，请联系管理员',
              type: 'error'
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      showEditForm(row) {
        this.editFormVisible = true;
        this.editForm = row;
        this.editForm.is_single = row.is_single.toString();
      },
      //获取商品分类树
      showGoodsForm(row) {
        this.activityId = row.activity_id;
        this.goodsData = [];
        this.selectGoodsData = [];
        this.selectGoodsVisible = true;
        this.$axios.get(config.api_url + '/menu/tree'
        ).then(response => {
          let data = response.data;
          if(data && data.length > 0) {
            let allmenu = [];
            for(const item of data) {
              if(item.sec_menu && item.sec_menu.length > 0) {
                let secMenu = [];
                for(const item1 of item.sec_menu) {
                  secMenu.push({
                    label: item1.sec_name,
                    value: item1.sec_id,
                    isFirst: 0
                  })
                }
                allmenu.push({
                  label: item.fname,
                  value: item.fid,
                  isFirst: 1,
                  children: secMenu
                })
              } else {
                allmenu.push({
                  label: item.fname,
                  value: item.fid,
                  isFirst: 1,
                })
              }
            }
            this.goodsTypeData = allmenu;
          } else {
            this.$message({
              message: '获取树失败',
              type: 'error'
            });
          }
        }).catch(error => {
          this.$message({
            message: '获取树异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //点击树节点，获取商品
      handleNodeClick(data) {
        if(data.isFirst === 0) {
          this.$axios.get(config.api_url + '/product/type/'+data.value
          ).then(response => {
            let data = response.data;
            if(data && data.length > 0) {
              let goodsData = [];
              for(const item of data) {
                goodsData.push({
                  name: item.pro_name,
                  value: item.pro_id
                })
              }
              this.goodsData = goodsData;
              //获取已关联商品
              this.$axios.get(config.api_url + '/activity/proids/'+this.activityId
              ).then(response => {
                if(response.data) {
                  let selectData = [];
                  for(const id of response.data.split(',')) {
                    for(const item of goodsData) {
                      if(item.value === parseInt(id)) {
                        selectData.push(item.name + '-' + id);
                      }
                    }
                  }
                  this.selectGoodsData = selectData;
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '获取商品异常，请联系管理员',
                  type: 'error'
                });
              })
            } else {
              this.$message({
                message: '未获取到商品',
                type: 'info'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '获取商品异常，请联系管理员',
              type: 'error'
            });
          });
        }
      },
      //提交选择商品
      selectGoodsSubmit() {
        if(this.selectGoodsData && this.selectGoodsData.length > 0) {
          let proIds = [];
          for(const item of this.selectGoodsData) {
            proIds.push(item.split('-')[1]);
          }
          this.$axios.post(config.api_url + '/activity/product', {
              pro_ids: proIds.toString(),
              activity_id: this.activityId
            }).then(response => {
            if(response.data.state) {
              this.$message({
                message: '提交成功',
                type: 'success'
              });
              this.selectGoodsVisible = false;
            } else {
              this.$message({
                message: '未获取到商品',
                type: 'info'
              });
            }
          }).catch(error => {
            this.$message({
              message: '获取商品异常，请联系管理员',
              type: 'error'
            });
          });
        }
      }
    },
    created() {
      this.search();
    }
  }
</script>

<style scoped>
  .select-goods {
    width: 100%;
  }
  .select-goods .goods-tree {
    width: 30%;
    height: 300px;
    overflow-y: scroll;
    float:left;
  }
  .select-goods .goods-data {
    cursor: default;
    background: #fff;
    border: 1px solid #d1dbe5;
    width: 60%;
    margin-left: 40%;
    height: 300px;
    overflow-y: scroll;
  }
  .el-checkbox {
    margin-left: 20px;
    margin-top: 7px;
  }
  .select-goods .no-goods {
    text-align: center;
    color: #5e7382;
    padding-top: 30%;
  }
</style>



// WEBPACK FOOTER //
// Festival.vue?ef8c6b2a